module.exports = __webpack_public_path__ + "static/media/image-analise.3b9424b7.png";